import { PANEL, MAP_TOOL } from '@tmapy/config';
export const SET_UI_MANAGER_STATE = '@ui-manager/SET_UI_MANAGER_STATE';
export const SET_PANEL = '@ui-manager/SET_PANEL';
export const SET_MAP_TOOL = '@ui-manager/SET_MAP_TOOL';
export const PANEL_DEFAULT_MAP_TOOL = {
    [PANEL.MEASURE]: MAP_TOOL.MEASURE_LINE,
    [PANEL.NOTES]: MAP_TOOL.NOTE_SELECT,
};
export const PANELS_WITH_DEFAULT_MAP_TOOL = Object.keys(PANEL_DEFAULT_MAP_TOOL);
//# sourceMappingURL=constants.js.map